import { render, staticRenderFns } from "./ProductComfortablePage.vue?vue&type=template&id=7ab21d3a&scoped=true&"
import script from "./ProductComfortablePage.vue?vue&type=script&lang=js&"
export * from "./ProductComfortablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab21d3a",
  null
  
)

export default component.exports